import z from 'zod';
import {tradeMessageDbSchema} from './tradeMessageDbSchema';
import {tradeWriteSchema} from './tradeWriteSchema';

export const tradeDbSchema = tradeWriteSchema.omit({message: true}).extend({
  /** message and appended to the messages array in db */
  messages: z.array(tradeMessageDbSchema).default([]),
});

export type TradeDb = z.infer<typeof tradeDbSchema>;
